import { Component, Input, Output, EventEmitter } from '@angular/core';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-primary-cta-button',
    imports: [MatProgressSpinnerModule],
    templateUrl: './primary-cta-button.component.html',
    styleUrls: ['./primary-cta-button.component.scss']
})
export class PrimaryCtaButtonComponent {
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() caption: string = '';
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() class: string = '';
  @Output() clickEvent = new EventEmitter<void>();

  handleClick() {
    if (!this.disabled && !this.loading) {
      this.clickEvent.emit();
    }
  }
}
